// 测试接口管理相关页面组件
import EmptyRouterView from '../components/EmptyRouterView/index.vue'
import ApiManagement from '../views/test/ApiManagement.vue'
import TestReportList from '../views/test/TestReportList.vue'

// 测试管理路由配置
export const testRoutes = {
  path: 'test',
  name: 'Test',
  component: EmptyRouterView,
  meta: {
    title: '测试管理',
    icon: 'el-icon-s-tools',
    hidden: false
  },
  children: [
    {
      path: 'api-management',
      name: 'ApiManagement',
      component: ApiManagement,
      meta: {
        title: '自动化测试接口管理',
        icon: 'el-icon-connection',
        hidden: false
      }
    },
    {
      path: 'test-report',
      name: 'TestReport',
      component: TestReportList,
      meta: {
        title: '自动化测试报告',
        icon: 'el-icon-document',
        hidden: false
      }
    }
  ]
}
